// Channel Category Colors
export const FEATURED = '#231928';
export const PLUTO = '#1e1928';
export const MOVIES = '#1e1e23';
export const NEWS = '#191e23';
export const SPORTS = '#19231e';
export const COMEDY = '#1e231e';
export const GEEKGAMING = '#1e2819';
export const CHILLOUT = '#232819';
export const ENTERTAINMENT = '#23231e';
export const LIFESTYLE = '#28231e';
export const CURIOSITY = '#281e23';
export const MUSICRADIO = '#231e23';
export const TIMEMARK_COLOR = '#fff';

export const UNSELECTED_ROW_ITEM_COLOR = '#151515';
export const SELECTED_ROW_ITEM_COLOR = '#1F1F1F';
export const ACTIVE_CURRENT_SELECTED_SCHEDULE_ITEM_COLOR = '#151515';
export const ACTIVE_CURRENT_SCHEDULE_ITEM_COLOR = '#1F1F1F';
export const HOVER_SCHEDULE_ITEM_COLOR = '#1F1F1F';
export const CATEGORY_BACKGROUND_COLOR = 'transparent';
